import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { HashRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { CartProvider } from "./context/CartContext.jsx";
import { LanguageProvider } from "./context/LanguageContext.jsx";

// Suporte para URLs sem hash geradas ou digitadas diretamente (ex: /acesso?k=... -> /#/acesso?k=...)
// Como a aplicação usa HashRouter, URLs sem # caem por padrão na rota raiz ("/")
if (
  !window.location.hash &&
  (window.location.pathname !== "/" || Boolean(window.location.search))
) {
  const cleanPath =
    window.location.pathname === "/" ? "" : window.location.pathname;
  const targetHashUrl = `${window.location.origin}/#${cleanPath}${window.location.search}`;
  window.location.replace(targetHashUrl);
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <HashRouter>
    <SnackbarProvider>
      <LanguageProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </LanguageProvider>
    </SnackbarProvider>
  </HashRouter>
);
